import { render, staticRenderFns } from "./admin-nav.vue?vue&type=template&id=183eea1a&scoped=true"
import script from "./admin-nav.vue?vue&type=script&lang=js"
export * from "./admin-nav.vue?vue&type=script&lang=js"
import style0 from "./admin-nav.vue?vue&type=style&index=0&id=183eea1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183eea1a",
  null
  
)

export default component.exports